import { InjectionToken } from '@angular/core';
export const AUTHORIZATION_PROVIDER = new InjectionToken<IAuthorizationProvider>(
  'AuthorizationInterceptor'
);

export interface IAuthorizationProvider {}